import HomeModule from "../modules/home/HomeModule";

const HomePage = () => {
  return <HomeModule />;
};

export default HomePage;
